import millify from 'millify';
import './index.scss';

import { ISwipe } from '../../api/interfaces';
import { Avatar } from '../avatar';
import RocketIcon from '../../assets/RocketIcon';

export interface ISwipeCard {
  swipe: ISwipe;
  onClick: () => void;
}

export const SwipeCard = ({ swipe, onClick }: ISwipeCard) => {
  return (
    <div className="swipe-card" onClick={onClick}>
      <Avatar
        glow={true}
        className="card-image"
        size="large"
        url={swipe.cover_image}
      />

      <div className="card-content">
        <div className="content-main">
          <h3 className="card-title">{swipe.title}</h3>

          <div className="swipe-author">
            <Avatar
              size="tiny"
              userName={swipe.author_name}
              url={swipe.author_image}
              glow={true}
            />
            <span className="author-name">{swipe.author_name}</span>
          </div>

          <p className="description">{swipe.short_description}</p>
        </div>

        <div className="runs">
          <RocketIcon color="var(--color-titanium-400)" />
          <span className="runs-count">{millify(swipe.runs)} runs</span>
        </div>
      </div>
    </div>
  );
};
